var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "formulate-input-element--checkbox-card" }, [
    _c(
      "input",
      _vm._b(
        {
          attrs: { type: "checkbox", id: _vm.context.id },
          domProps: {
            value: _vm.context.value,
            checked: _vm.context.model.includes(_vm.context.value)
          },
          on: { change: _vm.toggle, blur: _vm.context.blurHandler }
        },
        "input",
        _vm.context.attributes,
        false
      )
    ),
    _vm._v(" "),
    _c(
      "label",
      {
        staticClass: "formulate-input-element--checkbox-card__label",
        attrs: { for: _vm.context.id }
      },
      [
        _c(
          "span",
          { staticClass: "formulate-input-element--checkbox-card__thumb" },
          [
            _vm.icon
              ? _c("img", {
                  attrs: {
                    src: _vm.getAssetPath(_vm.icon, "icons"),
                    alt: _vm.context.label
                  }
                })
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "formulate-input-element--checkbox-card__text" },
          [_vm._v(_vm._s(_vm.customLabel))]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }